import { useMemo } from 'react';

import { TimeTrackingStopwatch } from '@work4all/models/lib/Classes/TimeTrackingStopwatch.entity';
import { DataRequest } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { useDataProvider } from './data-provider';
import { AppParts, useCanView } from './useCanView';

const REQUEST_DATA: TimeTrackingStopwatch = {
  id: null,
  startTime: null,
  stopTime: null,
  customerId: null,
  customer: {
    id: null,
    number: null,
    name: null,
  },
  projectId: null,
  project: {
    id: null,
    number: null,
    name: null,
  },
  projectProcessId: null,
  projectProcess: {
    id: null,
    number: null,
    process: null,
  },
  contractId: null,
  contract: {
    id: null,
    contractNumber: null,
    note: null,
  },
  contractPositionId: null,
  activityArticleId: null,
  activityArticle: {
    id: null,
    name: null,
  },
  ticketId: null,
  ticket: {
    id: null,
    title: null,
  },
  userId: null,
  user: {
    id: null,
    displayName: null,
  },
  comment: null,
};

const REQUEST: DataRequest = {
  data: REQUEST_DATA,
  entity: Entities.timeTrackingStopwatch,
  completeDataResponse: true,
};

type Return = {
  data: TimeTrackingStopwatch[];
  refetch: () => void;
};

export const useStopwatches = (): Return => {
  const skip = !useCanView(AppParts.STOP_WATCH);
  const { data, refetch } = useDataProvider<TimeTrackingStopwatch>(
    REQUEST,
    skip
  );

  return useMemo(() => {
    return {
      data: data ?? [],
      refetch,
    };
  }, [data, refetch]);
};
